import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentCode12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconDocumentCode12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 1h3.417v4.083H10V10.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5m7.178 2.833a1 1 0 0 1 .197.25H6.917V1.284zM9.5 12h-7A1.5 1.5 0 0 1 1 10.5v-9A1.5 1.5 0 0 1 2.5 0h3.718a2 2 0 0 1 1.357.53l2.782 2.568A2 2 0 0 1 11 4.568V10.5A1.5 1.5 0 0 1 9.5 12M3.146 5.416a.5.5 0 0 1 .708 0l1.87 1.87.353.354-.354.353-1.87 1.87a.5.5 0 0 1-.707-.707L4.663 7.64 3.146 6.124a.5.5 0 0 1 0-.708M5.5 9.5A.5.5 0 0 1 6 9h2.5a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentCode12);
